export default __webpack_public_path__ + "static/indoor12-6a4f37637a945e0923fee8fa7b72152e.webp";